import { useCallback, useContext, useState } from "react"
import { useSelector } from "react-redux"
import { createAudioVersionFetch, generateCleanAudioFetch } from "store/middlewares/region.crud"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { audioCuttingCompleteFetch } from "store/middlewares/markingWords.crud"
import { markingWordsHooks } from ".."
import { useParams } from "react-router-dom"
import qc from "keys/queryClient"
import { MarkingWordsContext } from "../MarkingWordsContext"
import { toast } from "react-toastify"
import { toastConfig } from "config"

const useGenerateAudioAndVersion = () => {
    const { setIsAudioMarkingMode } = useContext(MarkingWordsContext)

    const queryClient = useQueryClient()
    const params = useParams()

    let assessmentID = params.assessmentID

    const saveDraft = markingWordsHooks.useMarkingAudioSaveDraft()

    const [isProcessRunning, setIsProcessRunning] = useState(false);

    const { mutateAsync: generateCleanAudio, isPending: generateAudioPending } = useMutation({
        mutationFn: generateCleanAudioFetch
    })

    const { mutateAsync: _audioCuttingComplete, isPending: cuttingCompletePending } = useMutation({
        mutationFn: audioCuttingCompleteFetch
    })

    const { mutateAsync: createAudioVersion, isPending: createAudioVersionPending } = useMutation({
        mutationFn: createAudioVersionFetch
    })

    const generateAudioAndVersion = useCallback(async (regionsList) => {
        try {
            setIsProcessRunning(true);

            await saveDraft.action(regionsList)
            await generateCleanAudio(assessmentID)
            await _audioCuttingComplete({ id: assessmentID })
            await createAudioVersion(assessmentID)

            await queryClient.refetchQueries({
                queryKey: [qc.netoAudioFile, assessmentID],
                type: 'active',
                exact: true
            })

            toast("מצב חיתוך אודיו מכובה אוטומטית לאחר יצרת אודיו נטו", toastConfig)

            setIsAudioMarkingMode(false)

        } catch (error) {
            console.error("Error during audio generation process:", error);
        } finally {
            setIsProcessRunning(false);
        }
    }, [assessmentID])

    return {
        action: generateAudioAndVersion,
        isPending: isProcessRunning
    }
}

export default useGenerateAudioAndVersion